import React, { useState } from "react";
import "./../styles/ApplicationForm.scss";
import pppng from "../img/pppng.png";
import mailpngg from "../img/mailpngg.png";
import telefonpng from "../img/telefonpng.png";
import cveklepng from "../img/cveklepng.png";
import positionpng from "../img/positionpng.png";
import closesvg from "../img/closesvg.svg";
import Api from "../common/api";

const ApplicationForm = ({ data }) => {
  const lang = localStorage.getItem("lang");
  const phoneNumberHandler = (e) => {
    if (e.target.value.length === 11) {
      var phoneInput = e.target.value.match(/(\d{1})(\d{3})(\d{3})(\d{4})/);
      phoneInput =
        phoneInput[1] +
        "(" +
        phoneInput[2] +
        ")" +
        " - " +
        phoneInput[3] +
        " " +
        phoneInput[4];
      e.target.value = phoneInput;
    } else {
      return;
    }
  };

  const [info, setInfo] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    let data = {
      email:e.target.email.value,
      name:e.target.name.value,
      position:e.target.position.value,
      file:e.target.file.value,
      mobilephone:e.target.mobilephone.value,
    }
    
    Api.post("/home/SendHRMail/",data).then((res) => {
      setInfo(true);
    });
    
  }

  return (
    lang == "en" ? (

      <form onSubmit={handleSubmit}>
      {info ? (
        <p className="info-content">İstek Başarıyla Gönderilmiştir</p>
      ) :""}
      <h3 className="header-three sm-header">Application form</h3>
      <div className="application-form">
        <div className="input-container">
          <input placeholder="Name - Surname" name="name" />
          <img src={pppng} alt="asda" />
          <span></span>
        </div>
        <div className="input-container">
          <input placeholder="xxxx@xxxx.xxx" name="email" />
          <span></span>
          <img src={mailpngg} alt="asda" />
        </div>
        <div className="input-container">
          <input
            onChange={(e) => phoneNumberHandler(e)}
            id="phoneNumber"
            placeholder="(5xx)-xxx-xx-xx"
            name="mobilephone"
            type="text"
          />
          <span></span>
          <img src={telefonpng} alt="asda" />
        </div>
        <div className="input-container">
          <select id="position" name="position">
            <option style={{ padding: "15px 20px" }} value="s">
                Select the Position You Wish to Apply for
            </option>
            <option value="select">Select</option>
          </select>
          <span></span>
          <img src={positionpng} alt="asda" />
        </div>
        <div className="input-container">
          <input className="cv-add-input" placeholder="Add Cv" name="file"/>
          <span></span>
          <button className="file-picker">Choose File</button>
          <img src={cveklepng} alt="asda" />
        </div>
        <button className="submit-btn">Submit</button>
      </div>
    </form>

    ):(
      <form onSubmit={handleSubmit}>
      {info ? (
        <p className="info-content">İstek Başarıyla Gönderilmiştir</p>
      ) :""}
      <h3 className="header-three sm-header">Başvuru Formu</h3>
      <div className="application-form">
        <div className="input-container">
          <input placeholder="Adınız - Soyadınız" name="name" />
          <img src={pppng} alt="asda" />
          <span></span>
        </div>
        <div className="input-container">
          <input placeholder="xxxx@xxxx.xxx" name="email" />
          <span></span>
          <img src={mailpngg} alt="asda" />
        </div>
        <div className="input-container">
          <input
            onChange={(e) => phoneNumberHandler(e)}
            id="phoneNumber"
            placeholder="(5xx)-xxx-xx-xx"
            name="mobilephone"
            type="text"
          />
          <span></span>
          <img src={telefonpng} alt="asda" />
        </div>
        <div className="input-container">
          <select id="position" name="position">
            <option style={{ padding: "15px 20px" }} value="s">
              Başvurmak İstediğiniz Pozisyonu Seçiniz
            </option>
            <option value="sistem destek uzmanı">Sistem Destek Uzmanı</option>
          </select>
          <span></span>
          <img src={positionpng} alt="asda" />
        </div>
        <div className="input-container">
          <input className="cv-add-input" placeholder="Özgeçmiş Ekle" name="file"/>
          <span></span>
          <button className="file-picker">Dosya Seç</button>
          <img src={cveklepng} alt="asda" />
        </div>
        <button className="submit-btn">Gönder</button>
      </div>
    </form>

    )
    
    
  );
};

export default ApplicationForm;
